export const BRANCH_LOCATOR_IMPORTS_HREF = "#/admin/food-chain-branch-imports";

export function parseBranchLocatorApiError(error) {
  if (!error) {
    return "Branch locator request failed.";
  }
  if (typeof error === "string") {
    return error;
  }
  if (error.message) {
    return error.message;
  }
  return "Branch locator request failed.";
}

export function getBranchLocatorRunResultMessage(result) {
  if (!result) {
    return null;
  }

  if (result.message) {
    return result.message;
  }

  const importResult = result.import || result;
  if (result.dryRun) {
    return `Dry run validated ${importResult.validRowCount ?? 0} branch row(s).`;
  }

  return `Import completed: ${importResult.insertedCount ?? 0} inserted, ${importResult.updatedCount ?? 0} updated.`;
}
